<template>
  <div class="traceability" v-if="pageSet.tracePage">
    <SmallSquare content="<span class='s_c999 '>布局组件点击使用其他组件请使用拖拽的方式 <span class='s_cd41'>(布局组件可以和其他组件联合使用,组件也可单独使用)</span></span>" class='m-b-20 ' />
    <div class="s_fonts12 s_cd41 m-t-10 m-b-10"></div>
    <app-warp @click.stop="activeModule('index',-1)" canvasId="traceTemplate">
          <template #title>
            <div class="app-title" draggable="true"  >
              <LeftOutlined class="fz-20 m-l-10" /><span class="title fz-16">{{pageSet.tracePage.params.title}}</span>
            </div>
        </template>
      <template #app-sider-left>
        <transition-group appear tag="div">
          <div class="moduleContent" style="margin-right:20px">
            <div class="moduleTitle">组件库 </div>
            <div class="navs">
              <div class="navs-group">
                <div v-for="(value,index) in modules" :key="index">
                  <div class="title">{{value.title}}</div>
                  <div class="navs-components ">
                    <div class="special" v-for="(item,key) in value.modules" :key="key" :draggable="item.selectType=='drag'" @click="selectModule(item)" :style="'cursor:'+item.selectType=='drag'?'move':''" @dragstart="(e)=>dragModuleStart(e,item,value.type)" @dragend="dragend(item)" @dragenter.prevent="e=>e.preventDefault()">
                      <p class="item-icon">
                        <component v-if='item.icon' :is="item.icon"></component>
                      </p>
                      <p>{{item.name}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </template>
      <template #app-content>
        <div style="min-height:100%;padding:7px;" class="moduleMain" draggable="true" ref="layoutContent" :style="'background-color:'+pageSet.tracePage.style.backgroundColor" @drop.stop="dropModule" @dragover="e=>e.preventDefault()" >
          <transition-group appear tag="div" v-if="pageSet.tracePage.items.length">
            <div v-for="(item,key) in pageSet.tracePage.items" :key="key" @drop.stop="(e)=>dropModulePushLayout(e,item,key)">
               <!-- 'bottom_poistion':item.type=='bottomNav', -->
              <div class="app-module" style="overflow:hidden;padding:7px" draggable="true" 
              :class="{'app-active-module':moduleIndex==key,
               
                'joinModule':item.type=='join'
                }" 
              @click.stop="activeModule(item.type,key)" @dragstart="(e)=>dragstart(e,item,key)" @dragenter="e=>dragenter(e,item,key)" @dragend="e=>dragend(e,item)">
                <component :is="item.type" :data="item" style="overflow:hidden" 
                :style="'background-color:'+item.type=='join'?pageSet.tracePage.style.contentBackgroundColor:'transparent'+';border-radius:'+pageSet.tracePage.style.radius/2+'px'" :gobleStyle="pageSet.tracePage.style" />
                <div class="app-module-del" @click.stop="delMoudle(key)" v-if="key!=0&&item.type!='join'">
                  <DeleteOutlined style="font-size:18px" />
                </div>
              </div>
            </div>
          </transition-group>
        </div>
      </template>
      <template #app-sider>
        <div class="moduleContent " style="width:100%;margin-left:20px" @click.stop="()=>{}">
          <a-form :model="form" ref='ruleForm' :label-col="{span:5}" :wrapper-col="{span:19}">
            <!-- <component :is="formCreateData.type" :data="formCreateData" /> -->
            <!-- 普通一级的表单 -->
            <div v-if="formCreateData.type!='layout'&&formCreateData.type!='traceModule'">
              <formSeting :options="formCreateData" :moduleIndex="moduleIndex" v-on:update="updateForm" v-bind="$attrs"  />
            </div>
            <!-- 嵌套的表单 渲染布局中的组件 -->
            <div v-if="formCreateData.type=='layout'&&formCreateData.config.component.items.length">
              <div v-for="(v,k) in formCreateData.config.component.items" :key="k">
                <div class="outBox m-b-20 ">
                  <div class="insideBox s_flex_bian_c">
                    <p>{{v.name}}</p>
                    <DeleteOutlined @click.stop="delLayoutMoudle(formCreateData.config.type,k)" style="font-size:18px" />
                  </div>
                </div>
                <formSeting :options="v" :key="k" :moduleIndex="moduleIndex"  v-on:update="(e)=>updateLayoutForm(e,k)" v-bind="$attrs"  />
              </div>
            </div>
            <div v-if="formCreateData.type=='traceModule'&&formCreateData.items.length">
              <div v-for="(v,k) in formCreateData.items" :key="k">
                <div class="outBox m-b-20 ">
                  <div class="insideBox s_flex_bian_c">
                    <p>{{v.name}}</p>
                  </div>
                </div>
                <formSeting :options="v" :key="k" :moduleIndex="moduleIndex" v-on:update="(e)=>updateTraceModuleForm(e,k)" v-bind="$attrs"   />
              </div>
            </div>
          </a-form>
        </div>
      </template>
    </app-warp>
  </div>
</template>
<script>
import banner from "./components/banner/index";
import antiCounterfeiting from "./components/antiCounterfeiting/index";
import blank from "./components/blank/index";
import windows from "./components/windows/index";
import nav from "./components/nav/index";
import bottomNav from "./components/bottomNav/index";
import goods from "./components/goods/index";
import trace from "./components/trace/index";
import traceModule from "./components/traceModule/index";
import enterprise from "./components/enterprise/index";
import join from "./components/join/index";
import videoModule from "./components/video/index";
import formSeting from "./formComponents/index";
import config from "@/config";
import modules from "./module.js"; //基础组件数据
import * as Icon from "@ant-design/icons-vue";
import { onMounted, provide, reactive, ref, toRefs, watchEffect } from "vue";
import layout from "./layout/layout";
import { message } from "ant-design-vue";
import {getCanvas} from '@/libs/html2canvas'
export default {
  components: {
    traceModule,
    windows,
    blank,
    nav,
    banner,
    formSeting,
    ...Icon,
    layout,
    trace,
    goods,
    enterprise,
    bottomNav,
    join,
    videoModule,
    antiCounterfeiting
  },
  name: "normal",
  props:{template_data:Object,antis_fake_tem_data:Object},
  setup(props,{emit}) {
    // 模板页当前页面 记录
    const state = reactive({
      active: "index",
    });
    const activeKey = ref(1);
    var pageSet={tracePage:{}}
    var pageSet2 = reactive({
      tracePage: {
        params: { title: "溯源信息" },
        style: {
          radius: 24,
          backgroundColor: "#f8f8f8",
          contentBackgroundColor: "#ffffff",
          themeColor: "#4FA1FC",
        },
        items: [
            {
              type:'join',
              name:'抽奖浮窗',
              params:{
                 title:"前往抽奖",
              },
              style:{
                color: "#FB3939",
                image: config.oss[process.env.VUE_APP_type]+'web_base_assets/scan/join.png'
              }
          }
        ],
      },
    });
      watchEffect(()=>{
          pageSet=props.template_data
  
                
      })
    // themeColor themeBorderColor themeActiveColor themeBgColor
    //页面使用方便操作
    var modelRef = ref(pageSet.items);
    // 标记选中的 索引 一级索引
    const moduleIndex = ref(-1);
    // 标记选中的 索引 二级索引
    const secondIndex = ref(0);
    // 读取模块表单数据
    var formCreateData = ref({});
    const formCreate = (type, index) => {
      if (index == -1) {
        formCreateData.value = JSON.parse(
          JSON.stringify(Object.assign(pageSet.tracePage, { type }))
        );
      } else {
        formCreateData.value = JSON.parse(JSON.stringify(pageSet.tracePage.items[index]));
      }
    };
    // 激活模块
    const activeModule = (type, index) => {
      formCreate(type, index);
      moduleIndex.value = index;
    };
    // 模块
    const selectModule = (item) => {
      // 点击类组件直接追加到画布
      if (item.selectType == "click") {
        const moduleData = item.type == 'layout'
          ? { type: item.type, config: item.defaultData }
          : item.defaultData;
        pageSet.tracePage.items.push(JSON.parse(JSON.stringify(moduleData)));
        const currentIndex = pageSet.tracePage.items.length - 1;
        activeModule(item.type, currentIndex);
      }
    };
    // 表单更新数据
    const updateForm = (e) => {
      if (moduleIndex.value == -1) {
        pageSet.tracePage = e;
      } else if (moduleIndex.value >= 0) {
        pageSet.tracePage.items[moduleIndex.value] = e;
      }
    };
    // 子模块表单更新数据
    const updateLayoutForm = (e, k) => {
      pageSet.tracePage.items[moduleIndex.value].config.component.items[k] = e;
    };
    // 溯源模块的更新
    const updateTraceModuleForm=(e, k)=>{
      var flag=true
      if(!e.params.is_show){
       flag= pageSet.tracePage.items[moduleIndex.value].items[1-k].params.is_show
      }
      if(flag){
        pageSet.tracePage.items[moduleIndex.value].items[k]=e
      }else{
        pageSet.tracePage.items[moduleIndex.value].items[k].params.is_show=true
        message.error('至少显示一个模块')
      }
    }
    // 删除模块
    const delMoudle = (key) => {
      pageSet.tracePage.items.splice(key, 1);
    };
    // 删除布局中的组件
    const delLayoutMoudle = (type, k) => {
      pageSet.tracePage.items[moduleIndex.value].config.component.items.splice(
        k,
        1
      );
      pageSet.tracePage.items[
        moduleIndex.value
      ].config.component.components.splice(k, 1);
      formCreate(type, k);
    };
    const changePage = (e) => {
      if (e.target.value == 1) {
        state.active = "welcome";
        formCreate();
      }
      if (e.target.value == 2) {
        state.active = "index";
      }
    };
    const initData = () => {
      formCreate("index", -1);
          
    };
    onMounted(() => {
     setTimeout(() => {
        initData();
     }, 500);
    });
    // -------------拖拽基础模块放入布局开始----------
    // 追加moudule  拖拽开始
    const dragModuleStart = (e, item) => {
      e.dataTransfer.effectAllowed = "all";
      // 保存模块信息
      e.dataTransfer.setData("module", JSON.stringify(item));
      // e.dataTransfer.setDragImage
    };
    // 验证模块是否允许放入布局组件
    const verModuleIsBanDrop = (type) => {
      const rules = ['banner','windows','blank'];
      return rules.indexOf(type)!=-1
    };
    // 拖拽模块放入数组尾部   拖拽放下
    const layoutContent=ref()//容器
    const scrollTop=()=>{
      var offsetHight=layoutContent.value.offsetHight
    }
    const dropModule = (e) => {
      // 取出移动模块时 模块的数据
      const module = JSON.parse(e.dataTransfer.getData("module"));
      //  放置在数组最后一位
      pageSet.tracePage.items.push(module.defaultData);
      scrollTop()
    };
    // 拖拽模块放下布局容器 拖拽放下
    const dropModulePushLayout = (e, item, key) => {
      if(item.type=='layout'){
          // 取出移动模块时 模块的数据
      const module = JSON.parse(e.dataTransfer.getData("module"));
      // 验证模块
      var verification = verModuleIsBanDrop(module.defaultData.type);
      if (!verification)return message.error('高级组件只能搭配基础组件');
      // 取出被放下的容器的数据  包含两个数组 一个 components 组件名   items 具体的组件对象数据
      const dropComponentsData = item.config.component;
      dropComponentsData.components.push(module.defaultData.type);
      dropComponentsData.items.push(module.defaultData);
      // 把数据放入布局容器中  key 表示标记的索引
      pageSet.tracePage.items[key].config.component = dropComponentsData;
      }else{
        dropModule(e)
      }

      // 追加容器后滚动到最后面
     scrollTop()
    };
    // -------------拖拽基础模块放入布局结束----------

    // -----------------布局 顺序拖拽开始-------------------
    const start_index = ref(-1);
    const end_index = ref(-1);
    const dragstart = (e, value, index) => {
      start_index.value = index;
      e.dataTransfer.setData("start", index);
      e.dataTransfer.setData("value", value);
    };
    // 做最终操作
    const dragend = (value) => {
      if (start_index.value == -1) return;
      var start = start_index.value;
      var end = end_index.value;
      let oldValue = pageSet.tracePage.items[start];
      let newValue = pageSet.tracePage.items[end];
      let newItems = [...pageSet.tracePage.items];
      newItems[start] = newValue;
      newItems[end] = oldValue;
      // this.items一改变，transition-group就起了作用
      pageSet.tracePage.items = [...newItems];
      activeModule(value.type, end_index.value);
      // 重置索引
      start_index.value = -1;
    };
    // 记录移动过程中信息
    const dragenter = (e, value, index) => {
      end_index.value = index;
    };
    // -----------------布局 顺序拖拽结束-------------------
     const getThumb = () => {
          // 选中首页 用于截图
      return new Promise((resolve,reject)=>{
            // 选中首页 用于截图
            var element= document.getElementById('app-subject')
          getCanvas(element).then(res=>{
              resolve(res.image)
          }).catch(()=>{
              reject('/web_base_assets/scan/trace_abbreviation.png')
          })
      })
      // return "";
    };
     const submit = () => {
      var joinIndex = pageSet.tracePage.items.findIndex(v=>v.type=='join')
           if(joinIndex==-1){
            pageSet.tracePage.items.unshift({
              type:'join',
              name:'抽奖浮窗',
              params:{
                 title:"前往抽奖",
              },
              style:{
                color: "#FB3939",
                image: config.oss[process.env.VUE_APP_type]+'web_base_assets/scan/join.png'
              }
          })
          }
      emit("submit", pageSet);
      return pageSet;
    };
    return {
      submit,
      getThumb,
      dragModuleStart,
      dropModule,
      dropModulePushLayout,
      dragstart,
      dragenter,
      dragend,
      activeModule,
      activeKey,
      delLayoutMoudle,
      updateForm,
      updateLayoutForm,
      updateTraceModuleForm,
      pageSet,
      selectModule,
      delMoudle,
      formCreateData,
      ...toRefs(state),
      modelRef,
      changePage,
      moduleIndex,
      modules,
      secondIndex,
      layoutContent,
    };
  },
};
</script>
<style lang="less" scoped>
@import url("../module.less");
.app-module {
  position: relative;
  border: 2px dashed transparent;
  &:hover {
    border: 2px dashed #f04635 !important;

    .app-module-del {
      display: block;
    }
  }

  .app-module-del {
    z-index: 100;
    display: none;
    position: absolute;
    right: 2px;
    bottom: 2px;
    color: #204736;
    font-size: 12px;
  }
}

.app-active-module {
  border: 2px dashed #f04635 !important;
}
.app-title {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-top: 25px;
  background-color: #fff;
  height: 100%;
  display: flex;
  align-items: center;
  .title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
.bottom_poistion{
  position: absolute;
  width: 100%;
  bottom: 10px;
  left: 0;
}
.joinModule{
  width: initial!important;
  display: inline-block;
  padding:0!important;
  background-color: transparent!important;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  overflow: visible;
  z-index: 10;
}
</style>
